export default {
    workOrder_locationTab_name: "Nombre",
    workOrder_locationTab_type: "Tipo",
    workOrder_locationTab_address: "Dirección",
    workOrder_locationTab_description: "Descripción",
    workOrder_locationTab_createdOn: "Fecha de Creación",
    workOrder_locationTab_warningDeleteLocation: "No es posible eliminar la ubicación principal",
    workOrder_locationTab_deleteLocations: "Eliminar Ubicaciones",
    workOrder_locationTab_regular: "Regular",
    workOrder_locationTab_main: "Principal",
    workOrder_locationTab_billing: "Facturación",
}